
export function parseJsonRobustly(jsonString) {
    if (typeof jsonString !== "string") {
        return jsonString;
    }

    let cleanedData = jsonString
        .replace(/```json\s*|\s*```/g, "")
        .trim();

    if (!cleanedData) {
        throw new Error("Empty content after cleaning");
    }

    try {
        return JSON.parse(cleanedData);
    } catch (parseError) {
        try {
            const unescapedData = cleanedData.replace(/\\"/g, '"');
            return JSON.parse(unescapedData);
        } catch (unescapedError) {
            try {

                const simpleObjectPattern = /\{[^}]*\}/;
                const simpleArrayPattern = /$$[^$$]*$$/;
                
                let match = cleanedData.match(simpleObjectPattern);
                if (match && match[0]) {
                    return JSON.parse(match[0]);
                }
                
                match = cleanedData.match(simpleArrayPattern);
                if (match && match[0]) {
                    return JSON.parse(match[0]);
                }
                
                throw new Error("No valid JSON pattern found");
            } catch (extractError) {
                throw parseError;
            }
        }
    }
}

export default { parseJsonRobustly };